import { CustomEnumMode, CustomParamScenario, CustomEnumType, CustomEnumValue } from './model';
import { fetchApi, ApiResponse } from './common';

// 自定义枚举类型相关请求接口
export interface CreateCustomEnumTypeRequest {
  name: string;
  scenario: CustomParamScenario;
  mode: CustomEnumMode;
  is_enabled: boolean;
  order: number;
  extra?: Record<string, any>;
  visible_to_customer: boolean;
}

export interface UpdateCustomEnumTypeRequest {
  name?: string;
  scenario?: CustomParamScenario;
  order?: number;
  extra?: Record<string, any>;
  visible_to_customer?: boolean;
}

// 自定义枚举值相关请求接口
export interface CreateCustomEnumValueRequest {
  type_id: string;
  name: string;
  description?: string;
  order: number;
  extra?: Record<string, any>;
  is_enabled: boolean;
}

export interface UpdateCustomEnumValueRequest {
  name?: string;
  description?: string;
  order?: number;
  extra?: Record<string, any>;
}

// 自定义枚举API请求函数
export const customEnumApi = {
  // 获取自定义枚举类型列表
  listCustomEnumTypes: async (scenario?: CustomParamScenario): Promise<ApiResponse<CustomEnumType[]>> => {
    const params = new URLSearchParams();
    if (scenario) {
      params.append('scenario', scenario);
    }
    const url = params.toString() 
      ? `/api/doctor_view/custom_enum_types?${params.toString()}` 
      : '/api/doctor_view/custom_enum_types';
    return fetchApi<CustomEnumType[]>(url, 'GET');
  },

  // 设置自定义枚举类型启用状态
  setCustomEnumTypeEnabled: async (id: string, isEnabled: boolean): Promise<ApiResponse<CustomEnumType>> => {
    return fetchApi<CustomEnumType>(`/api/doctor_view/custom_enum_types/${id}/set_enabled`, 'PUT', {
      is_enabled: isEnabled
    });
  },

  // 设置自定义枚举值启用状态
  setCustomEnumValueEnabled: async (id: string, isEnabled: boolean): Promise<ApiResponse<CustomEnumValue>> => {
    return fetchApi<CustomEnumValue>(`/api/doctor_view/custom_enum_values/${id}/set_enabled`, 'PUT', {
      is_enabled: isEnabled
    });
  },

  // 创建自定义枚举类型
  createCustomEnumType: async (data: CreateCustomEnumTypeRequest): Promise<ApiResponse<CustomEnumType>> => {
    return fetchApi<CustomEnumType>('/api/doctor_view/custom_enum_types', 'POST', data);
  },

  // 更新自定义枚举类型
  updateCustomEnumType: async (id: string, data: UpdateCustomEnumTypeRequest): Promise<ApiResponse<CustomEnumType>> => {
    return fetchApi<CustomEnumType>(`/api/doctor_view/custom_enum_types/${id}`, 'PUT', data);
  },

  // 获取自定义枚举值列表
  listCustomEnumValues: async (typeId: string): Promise<ApiResponse<CustomEnumValue[]>> => {
    return fetchApi<CustomEnumValue[]>(`/api/doctor_view/custom_enum_values?type_id=${typeId}`, 'GET');
  },

  // 创建自定义枚举值
  createCustomEnumValue: async (data: CreateCustomEnumValueRequest): Promise<ApiResponse<CustomEnumValue>> => {
    return fetchApi<CustomEnumValue>('/api/doctor_view/custom_enum_values', 'POST', data);
  },

  // 更新自定义枚举值
  updateCustomEnumValue: async (id: string, data: UpdateCustomEnumValueRequest): Promise<ApiResponse<CustomEnumValue>> => {
    return fetchApi<CustomEnumValue>(`/api/doctor_view/custom_enum_values/${id}`, 'PUT', data);
  }
};